export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-19.jpg'),
        title: 'ソフトウェア開発と保守',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'エンタープライズアプリケーションの運用と保守',
      description: `<p style="font-size:1.05rem">企業の情報化が進むにつれて、情報システムは大規模かつ複雑になっています。エンタープライズアプリケーションの運用・保守には高い難易度と負荷が伴います。MaesInfoはカスタムのアプリケーション設計・開発サービスを提供し、予算内で期日通りに品質を満たしたプロジェクトを納品します。お客様のアプリケーションや製品の要件を明確化し、ライフサイクル全体の管理と保守を支援します。
MaesInfoは経験豊富なグローバル開発チームと技術専門家を擁し、より標準化・専門化されたカスタムソリューションを提供します。私たちのチームはアプリケーションをより効率的かつ安定して稼働させ、障害発生時にも迅速に対応します。</p>`
    },
    {
      title: '提供可能な内容：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-19.jpg')+`)"></span>
      <span class="list">
      <i></i>業界向けアプリの開発・保守<br/>
      <i></i>カスタムソフトウェアパッケージの提供<br/>
      <i></i>モバイルアプリと組込み開発<br/>
      <i></i>付加価値サービスのためのアプリ開発<br/>
      <i></i>サプライチェーン管理アプリの開発<br/>
      <i></i>エンタープライズアプリケーションの統合<br/>
      <i></i>アプリケーションのライフサイクルサポート<br/>
      <i></i>サービス指向アーキテクチャ（SOA）<br/>
      <i></i>品質保証とテスト

      </span>`
    }
  ]
}
